import { API } from 'common/constants/urls';
import { post } from 'common/axiosClient';
import { FixPayappHeadersDTO, FixPayappRowDTO } from './openai.type';

export const fixPayappHeaders = async (dto: FixPayappHeadersDTO) => {
  return await post(`${API.OPEN_AI}/fix-payapp-headers`, dto);
};
export const fixPayappRow = async (dto: FixPayappRowDTO) => {
  return await post(`${API.OPEN_AI}/fix-payapp-row`, dto);
};
